// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j7-6";
export var emphasizeQuantity = "_j7-3";
export var flatBottomCorners = "_j7-5";
export var productImage = "_j7-0";
export var quantityContainer = "_j7-2";
export var tooltip = "_j7-1";
export var wrapAndEllipsesOverflow = "_j7-4";